import { c as _c } from "react/compiler-runtime";
import type { LineOfCoverageMetadata } from '@newfront-insurance/coverage-api';
import type { NextApiSubscription, ConfigInterface } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useContext } from 'react';
import { routes } from '../bff/routes';
import type { GetLineOfCoverageMetadataParams, GetLineOfCoverageMetadataResponse } from '../bff/types';
import { CoverageApiContext } from '../provider';
interface Params extends Omit<GetLineOfCoverageMetadataParams, 'lineOfCoverageVersion'> {
  lineOfCoverageVersion?: number;
}
export function useLineOfCoverageMetadata(params, config) {
  const $ = _c(3);
  const {
    basePath
  } = useContext(CoverageApiContext);
  let t0;
  if ($[0] !== basePath || $[1] !== params) {
    t0 = routes.linesOfCoverageMetadata.getUrl({
      ...params,
      lineOfCoverageVersion: params.lineOfCoverageVersion?.toString() ?? undefined
    }, basePath);
    $[0] = basePath;
    $[1] = params;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useNextApiSubscription(t0, config);
}